import { graphFetch } from './fetchConfig';

/**
 * 매뉴얼 조회
 * @param menuId
 * @returns {Promise<*>}
 */
export const getVideoByMenuId = async (menuId) => {
  const mutation = `
    mutation getVideoByMenuId($menuId: String!) {
      getVideoByMenuId(menuId: $menuId) {
        videoId
        videoTitle
        attachmentPath
        videoContents
        videoFileName
        readCount
        menuId
        priorityLevel
        updateDate
        flagActive
      }
    }
  `;

  const response = await graphFetch(mutation, { menuId });
  return response.getVideoByMenuId;
};

/**
 * 매뉴얼 조회수 업데이트
 * @param menuId
 * @returns {Promise<*>}
 */
export const upReadCountForVideo = async (menuId) => {
  const mutation = `
    mutation upReadCountForVideo($menuId: String!) {
      upReadCountForVideo(menuId: $menuId)
    }
  `;

  const response = await graphFetch(mutation, { menuId });
  return response.upReadCountForVideo;
};
